import { addOpacityToThemeColor } from '@/utils/styles/addOpacity';
import type { variables } from '../mpanels/variables';

type Variables = typeof variables;

const createMuiPickersPopperStyles = (variables: Variables) => ({
    styleOverrides: {
        paper: {
            boxShadow: variables.boxShadows.popoverShadow,
        },
    },
});

const createMuiPickersDayStyles = (variables: Variables) => ({
    styleOverrides: {
        root: {
            '&.MuiPickersDay-today': {
                borderColor: addOpacityToThemeColor(variables.colors.palette.primary.main, 0.6),
            },
            '&.MuiPickersDay-root.Mui-selected': {
                backgroundColor: variables.colors.palette.primary.main,
                '&:hover': {
                    backgroundColor: addOpacityToThemeColor(
                        variables.colors.palette.primary.main,
                        0.8,
                    ),
                },
            },
        },
    },
});

export { createMuiPickersPopperStyles, createMuiPickersDayStyles };
